import React, { useState, useEffect, useCallback } from 'react';
import { apiFetch } from './api';

export default function VendorMapping({ company, canEdit, initialRouteId = '', routeOptions = null }) {
  const [routes, setRoutes] = useState(routeOptions || []);
  const [selectedRoute, setSelectedRoute] = useState(initialRouteId);
  const [vendors, setVendors] = useState([]);
  const [form, setForm] = useState({
    vendorCode: '',
    name: '',
    openingStock: '',
    month: String(new Date().getMonth() + 1),
    year: String(new Date().getFullYear())
  });
  const [loading, setLoading] = useState(false);
  const months = [
    { value: '1', label: 'Jan' }, { value: '2', label: 'Feb' }, { value: '3', label: 'Mar' }, { value: '4', label: 'Apr' },
    { value: '5', label: 'May' }, { value: '6', label: 'Jun' }, { value: '7', label: 'Jul' }, { value: '8', label: 'Aug' },
    { value: '9', label: 'Sep' }, { value: '10', label: 'Oct' }, { value: '11', label: 'Nov' }, { value: '12', label: 'Dec' }
  ];

  const loadRoutes = useCallback(() => {
    if (routeOptions) {
      setRoutes(routeOptions);
      return Promise.resolve();
    }
    return apiFetch(`/api/routes`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(allRoutes => {
        setRoutes(allRoutes.filter(route => route.supervisor && route.supervisor.company === company));
      });
  }, [company, routeOptions]);

  const loadVendors = useCallback((routeId) => {
    if (!routeId) { setVendors([]); return Promise.resolve(); }
    return apiFetch(`/api/vendors/route/${routeId}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(setVendors);
  }, []);

  useEffect(() => {
    loadRoutes();
  }, [company, loadRoutes]);

  useEffect(() => {
    loadVendors(selectedRoute);
  }, [selectedRoute, loadVendors]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = async e => {
    e.preventDefault();
    if (!selectedRoute || !form.vendorCode || !form.name) return;
    setLoading(true);
    const payload = {
      vendorCode: form.vendorCode,
      name: form.name,
      openingStock: parseInt(form.openingStock) || 0,
      returnCanGood: 0,
      returnCanDamage: 0,
      givenCanOld: 0,
      givenCanNew: 0,
      remark: form.remark,
      month: parseInt(form.month) || new Date().getMonth() + 1,
      year: parseInt(form.year) || new Date().getFullYear(),
      routeId: selectedRoute
    };
    const res = await apiFetch(`/api/vendors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (res.ok) {
      const now = new Date();
      setForm({ vendorCode: '', name: '', openingStock: '', month: String(now.getMonth() + 1), year: String(now.getFullYear()) });
      await loadVendors(selectedRoute);
    }
    setLoading(false);
  };

  return (
    <div style={{padding:0,background:'none',boxShadow:'none',margin:0,width:'100%'}}>
      {routes.length > 1 && (
        <div style={{marginBottom:16}}>
          <select value={selectedRoute} onChange={e=>setSelectedRoute(e.target.value)} style={{padding:8,borderRadius:6,border:'1px solid #e6eaf0',minWidth:220}}>
            <option value="">Select Route</option>
            {routes.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
          </select>
        </div>
      )}
      {canEdit && selectedRoute && (
        <form onSubmit={handleAdd} style={{display:'flex',flexDirection:'column',gap:16,marginBottom:24,alignItems:'center',width:'100%'}}>
          <input name="vendorCode" placeholder="Code" value={form.vendorCode} onChange={handleChange} required style={{padding:6,borderRadius:6,border:'1px solid #e6eaf0',width:'80%'}} />
          <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required style={{padding:6,borderRadius:6,border:'1px solid #e6eaf0',width:'80%'}} />
          <input name="openingStock" placeholder="Opening" value={form.openingStock} onChange={handleChange} style={{padding:6,borderRadius:6,border:'1px solid #e6eaf0',width:'80%'}} />
          <select name="month" value={form.month} onChange={handleChange} style={{padding:6,borderRadius:6,border:'1px solid #e6eaf0',width:'80%',appearance:'none',WebkitAppearance:'none',MozAppearance:'none'}}>
            {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          <input name="year" placeholder="Year" value={form.year} onChange={handleChange} style={{padding:6,borderRadius:6,border:'1px solid #e6eaf0',width:'80%'}} />
          <button className="btn primary" type="submit" disabled={loading} style={{height:38,width:'80%'}}>Add</button>
        </form>
      )}
      {/* Vendor table hidden as per request. Entries are not displayed. */}
    </div>
  );
}
